import LyftImg from "../assets/lyft-image.webp";
import ForageBgImg from "../assets/forage-bg-image.png";
import AWSImg from "../assets/aws-image.png";
import UdemyBgImg from "../assets/udemy-bg-image.png";
import SparkImg from "../assets/spark-image.png";
import UMImg from "../assets/um-image.png";
import CourseraBgImg from "../assets/coursera-bg-img.png";
import JHUImg from "../assets/jhu-image.png";
const AboutCertificatesData = [
  {
    bgimgsrc: ForageBgImg,
    imgsrc: LyftImg,
    title:
      "Lyft Back-End Engineering Virtual Experience Program on Forage - July 2023",
    description:
      "Completed an intensive program focused on mastering software architecture, refactoring, unit testing, and test-driven development (TDD) using Python. Equipped with the skills to design clean solutions, refactor messy code, and implement rigorous testing for robust back-end applications. Excited to apply these valuable skills to real-world projects in the realm of web development.",
    link:
      "https://forage-uploads-prod.s3.amazonaws.com/completion-certificates/Lyft/xSw9echtixLAoPdsH_Lyft_7SeePJvw6DCpwdK3h_1690139977052_completion_certificate.pdf"
  },
  {
    bgimgsrc: UdemyBgImg,
    imgsrc: AWSImg,
    title: "[NEW] Ultimate AWS Certified Cloud Practitioner - 2022",
    description:
      "I have mastered the fundamentals of AWS and gained valuable insights into utilizing its services effectively. This certification has enabled me to confidently launch EC2 instances, manage IAM roles, host static websites, establish connections to DynamoDB databases, and implement lambda functions for seamless and optimized calculations, showcasing my practical application of AWS knowledge.",
    link:
      "https://www.udemy.com/certificate/UC-ebc3164a-ce84-4190-beb6-7cb7cde42756/"
  },
  {
    bgimgsrc: UdemyBgImg,
    imgsrc: SparkImg,
    title: "Data Engineering Essentials using SQL, Python, and PySpark",
    description:
      "Learned professional level skills well-equipped to tackle real-world data engineering challenges and build robust data pipelines for analysis and insights. Gained in-depth knowledge of spark, spark sql, and using spark for evaluation of BigData.",
    link:
      "https://www.udemy.com/certificate/UC-f511d8e3-38f8-4bb4-98cc-8063d7560f27/"
  },
  {
    bgimgsrc: CourseraBgImg,
    imgsrc: UMImg,
    title: "Python Data Structures",
    description:
      "This course was offered online by University of Michigan. Goal wat to adapt python by learning the in-built data structures provided. Applying them by doing python projects.",
    link: "https://www.coursera.org/account/accomplishments/verify/6F7MZEV3SYZD"
  },
  {
    bgimgsrc: CourseraBgImg,
    imgsrc: UMImg,
    title: "Programming for Everybody (Getting Started with Python)",
    description:
      "Learning the trending language Python. Figuring out the syntax difference between Java, C++ and Python.",
    link:
      "https://www.coursera.org/account/accomplishments/certificate/XELD3MTPDUBR"
  },
  {
    bgimgsrc: CourseraBgImg,
    imgsrc: JHUImg,
    title: "HTML, CSS, and Javascript for Web Developers",
    description:
      "The basics of web development that helps in creating dynamic websites.",
    link: "https://www.coursera.org/account/accomplishments/verify/JQTF7DC69N7R"
  }
];

export default AboutCertificatesData;
